
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2073.961-1770a1.836 1.836 0 00-.557-1.348 1.859 1.859 0 00-1.367-.557 1.872 1.872 0 00-.962.254 1.925 1.925 0 00-.693.688 1.845 1.845 0 00-.259.962 1.819 1.819 0 00.259.957 1.978 1.978 0 00.693.688 1.845 1.845 0 00.962.259 1.863 1.863 0 00.972-.259 1.978 1.978 0 00.693-.688 1.819 1.819 0 00.259-.956zm6.865 0a1.91 1.91 0 00-2.861-1.65 1.938 1.938 0 00-.688.688 1.845 1.845 0 00-.259.962 1.819 1.819 0 00.255.96 1.991 1.991 0 00.688.688 1.9 1.9 0 001.914 0 1.991 1.991 0 00.688-.688 1.819 1.819 0 00.264-.96zm6.895 0a1.9 1.9 0 00-1.914-1.9 1.917 1.917 0 00-.977.254 1.879 1.879 0 00-.947 1.65 1.846 1.846 0 00.254.957 1.926 1.926 0 00.693.688 1.889 1.889 0 00.977.259 1.845 1.845 0 00.962-.259 1.978 1.978 0 00.693-.688 1.819 1.819 0 00.259-.961z"}})])])
          )
        }
      }
    